<div *ngIf="currentUser">
  <div
    id="title-user-guides-and-videos"
    class="page-title-section page-padding-x page-padding-y"
  >
    <h2>User Guides and Videos</h2>
  </div>

  <div
    id="general-user-guides"
    class="bg-grey-100 page-padding-x"
  >
    <h3 class="section-title">General</h3>
    <div class="section-content">
      <app-links-grid
        id="general-links"
        [links]="generalLinks"
        (actionClicked)="onActionClicked($event)"
      ></app-links-grid>
    </div>
  </div>

  <div
    id="committee-workspace-guides-and-videos"
    class="page-padding-x"
  >
    <h3 class="section-title">Committee Workspace</h3>
    <div class="section-content">
      <app-links-grid
        id="committee-workspace-links"
        [links]="committeeWorkspaceLinks"
        (actionClicked)="onActionClicked($event)"
      ></app-links-grid>
    </div>
  </div>
  <div id="project-proposal-portal-user-guides" class="bg-grey-100 page-padding-x">
    <h3 class="section-title">Project Proposal Portal</h3>
    <div class="section-content">
      <app-links-grid
        id="project-proposal-portal-link"
        [links]="projectProposalPortalLinks"
        (actionClicked)="onActionClicked($event)"
      ></app-links-grid>
    </div>
  </div>

    <div
      id="drafting-tools-user-guides"
      class="page-padding-x"
      *ngIf="draftingToolsLinks && draftingToolsLinks.length > 0">
    <h3 class="section-title">Drafting Tools</h3>
    <div class="section-content">
      <app-links-grid
        id="drafting-tools-links"
        [links]="draftingToolsLinks"
        (actionClicked)="onDraftingToolsActionClicked($event)"
      ></app-links-grid>
    </div>
  </div>
</div>
